import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import Navbar from "../../components/navbar/Navbar";
import { BsTag, BsTags } from "react-icons/bs";
import { BiCategory, BiTagAlt } from "react-icons/bi";
import {
  MdOutlineColorLens,
  MdOutlineMenu,
  MdOutlineClose,
} from "react-icons/md";
import { CgShapeCircle } from "react-icons/cg";
import { TiDeleteOutline } from "react-icons/ti";
import { addProduct } from "../../redux/cartSlice";
import { useDispatch } from "react-redux";

const Categories = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const homeCategory = location.state?.category;
  const [category, setCategory] = useState(
    homeCategory
      ? process.env.REACT_APP_API_URL + `/product?category=${homeCategory}`
      : process.env.REACT_APP_API_URL + "/product/"
  );
  const [products, setProducts] = useState([]);
  const [filters, setFilters] = useState([]);
  const [toggle, setToggle] = useState(false);

  useEffect(() => {
    const getProducts = async () => {
      try {
        // eslint-disable-next-line no-unused-vars
        const result = await axios.get(category).then((res) => {
          setProducts(res.data);
          setFilters(res.data);
        });
      } catch (error) {
        console.log(error);
      }
    };
    getProducts();
  }, [category]);

  const handleCategory = (value) => {
    if (value === "" || value === "all") {
      setToggle(false)
      return setCategory(process.env.REACT_APP_API_URL + "/product");
    } else {
      setToggle(false)
      return setCategory(process.env.REACT_APP_API_URL + "/product?category=" + value);
    }
  };

  const handleFilters = (value) => {
    const filter = products?.filter(
      (product) =>
        product.categories.includes(value) ||
        product.color.includes(value) ||
        product.brand.includes(value)
    );
    setFilters(filter);
    if (value === "" || value === "all") {
      setFilters(products);
    }
    setToggle(false)
  };

  const handleSort = (sort) => {
    if (sort === "low") {
      setFilters((prev) => [...prev].sort((a, b) => a.price - b.price));
    } else if (sort === "hight") {
      setFilters((prev) => [...prev].sort((a, b) => b.price - a.price));
    } else if (sort === "newest") {
      setFilters((prev) => [...prev].sort((a, b) => a.createdAt - b.createdAt));
    } else {
      setFilters((prev) => [...prev].sort((a, b) => b.createdAt - a.createdAt));
    }
  };

  return (
    <>
      <Navbar categoriesSearch={setFilters}/>
      <div className="Categories flex gap-2 mx-2 lg:mx-20 mt-20 justify-center">
        <div className="block lg:hidden h-full">
          {toggle ? (
            <div className="sidebar flex flex-col w-60 p-4 pt-0 gap-4 bg-white absolute top-140 left-0 z-50 drop-shadow-xl">
              <div className="category flex flex-col mb-2 border-b border-gray-200">
                <h3 className="flex gap-2 items-center mb-4 text-base font-Roboto font-medium text-gray-700">
                  <BiCategory className="text-base text-gray-700" />
                  Category
                </h3>
                <ul className="ml-2">
                  <li
                    onClick={(event) => handleCategory("all")}
                    className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
                  >
                    <BiTagAlt className="text-sm text-gray-500" />
                    All
                  </li>
                  <li
                    onClick={() => handleCategory("electronics")}
                    className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
                  >
                    <BiTagAlt className="text-sm text-gray-500" />
                    Electronics
                  </li>
                  <li
                    onClick={() => handleCategory("laptop")}
                    className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
                  >
                    <BiTagAlt className="text-sm text-gray-500" />
                    Computer
                  </li>
                  <li
                    onClick={() => handleCategory("gaming")}
                    className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
                  >
                    <BiTagAlt className="text-sm text-gray-500" />
                    Gaming
                  </li>
                  <li
                    onClick={() => handleCategory("phone")}
                    className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
                  >
                    <BiTagAlt className="text-sm text-gray-500" />
                    Phone
                  </li>
                  <li
                    onClick={() => handleCategory("accessories")}
                    className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
                  >
                    <BiTagAlt className="text-sm text-gray-500" />
                    Accessories
                  </li>
                  <li
                    onClick={() => handleCategory("cloths")}
                    className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
                  >
                    <BiTagAlt className="text-sm text-gray-500" />
                    Cloths
                  </li>
                  <li
                    onClick={() => handleCategory("shoes")}
                    className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
                  >
                    <BiTagAlt className="text-sm text-gray-500" />
                    Shoes
                  </li>
                </ul>
              </div>

              <div className="color flex flex-col mb-2 border-b border-gray-200 pb-4">
                <h3 className="flex gap-2 items-center mb-4 text-base font-Roboto font-medium text-gray-700">
                  <MdOutlineColorLens className="text-base text-gray-700" />
                  Color
                </h3>
                <ul className="">
                  <li
                    onClick={() => handleFilters("all")}
                    className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
                  >
                    <TiDeleteOutline
                      className="text-sm drop-shadow-md"
                      color="gray"
                    />
                    All
                  </li>
                  <li
                    onClick={() => handleFilters("white")}
                    className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
                  >
                    <CgShapeCircle
                      className="text-sm drop-shadow-md"
                      color="white"
                    />
                    White
                  </li>
                  <li
                    onClick={() => handleFilters("black")}
                    className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
                  >
                    <CgShapeCircle
                      className="text-sm drop-shadow-md"
                      color="black"
                    />
                    Black
                  </li>
                  <li
                    onClick={() => handleFilters("silver")}
                    className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
                  >
                    <CgShapeCircle
                      className="text-sm drop-shadow-md"
                      color="silver"
                    />
                    Silver
                  </li>
                  <li
                    onClick={() => handleFilters("green")}
                    className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
                  >
                    <CgShapeCircle
                      className="text-sm drop-shadow-md"
                      color="green"
                    />
                    Green
                  </li>
                  <li
                    onClick={() => handleFilters("purple")}
                    className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
                  >
                    <CgShapeCircle
                      className="text-sm drop-shadow-md"
                      color="purple"
                    />
                    Purple
                  </li>
                  <li
                    onClick={() => handleFilters("blue")}
                    className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
                  >
                    <CgShapeCircle
                      className="text-sm drop-shadow-md"
                      color="blue"
                    />
                    Blue
                  </li>
                  <li
                    onClick={() => handleFilters("red")}
                    className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
                  >
                    <CgShapeCircle
                      className="text-sm drop-shadow-md"
                      color="red"
                    />
                    Red
                  </li>
                </ul>
              </div>

              <div className="brand flex flex-col mb-2">
                <h3 className="flex gap-2 items-center mb-4 text-base font-Roboto font-medium text-gray-700">
                  <BsTags className="text-base text-gray-700" />
                  Brand
                </h3>
                <ul className="ml-2 flex flex-col">
                  <li
                    onClick={() => handleFilters("all")}
                    className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
                  >
                    <BsTag className="text-sm text-gray-500" />
                    All
                  </li>
                  <li
                    onClick={() => handleFilters("apple")}
                    className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
                  >
                    <BsTag className="text-sm text-gray-500" />
                    Apple
                  </li>
                  <li
                    onClick={() => handleFilters("microsoft")}
                    className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
                  >
                    <BsTag className="text-sm text-gray-500" />
                    Microsoft
                  </li>
                  <li
                    onClick={() => handleFilters("sony")}
                    className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
                  >
                    <BsTag className="text-sm text-gray-500" />
                    Sony
                  </li>
                  <li
                    onClick={() => handleFilters("samsung")}
                    className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
                  >
                    <BsTag className="text-sm text-gray-500" />
                    Samsung
                  </li>
                  <li
                    onClick={() => handleFilters("razer")}
                    className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
                  >
                    <BsTag className="text-sm text-gray-500" />
                    Razer
                  </li>
                  <li
                    onClick={() => handleFilters("logitech")}
                    className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
                  >
                    <BsTag className="text-sm text-gray-500" />
                    Logitech
                  </li>
                </ul>
              </div>
            </div>
          ) : null}
        </div>

        <div className="sidebar hidden lg:flex flex-col w-60 h-full p-4 pt-0 gap-4 bg-white">
          <div className="category flex flex-col mb-2 border-b border-gray-200">
            <h3 className="flex gap-2 items-center mb-4 text-base font-Roboto font-medium text-gray-700">
              <BiCategory className="text-base text-gray-700" />
              Category
            </h3>
            <ul className="ml-2">
              <li
                onClick={(event) => handleCategory("all")}
                className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
              >
                <BiTagAlt className="text-sm text-gray-500" />
                All
              </li>
              <li
                onClick={() => handleCategory("electronics")}
                className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
              >
                <BiTagAlt className="text-sm text-gray-500" />
                Electronics
              </li>
              <li
                onClick={() => handleCategory("laptop")}
                className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
              >
                <BiTagAlt className="text-sm text-gray-500" />
                Computer
              </li>
              <li
                onClick={() => handleCategory("gaming")}
                className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
              >
                <BiTagAlt className="text-sm text-gray-500" />
                Gaming
              </li>
              <li
                onClick={() => handleCategory("phone")}
                className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
              >
                <BiTagAlt className="text-sm text-gray-500" />
                Phone
              </li>
              <li
                onClick={() => handleCategory("accessories")}
                className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
              >
                <BiTagAlt className="text-sm text-gray-500" />
                Accessories
              </li>
              <li
                onClick={() => handleCategory("cloths")}
                className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
              >
                <BiTagAlt className="text-sm text-gray-500" />
                Cloths
              </li>
              <li
                onClick={() => handleCategory("shoes")}
                className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
              >
                <BiTagAlt className="text-sm text-gray-500" />
                Shoes
              </li>
            </ul>
          </div>

          <div className="color flex flex-col mb-2 border-b border-gray-200 pb-4">
            <h3 className="flex gap-2 items-center mb-4 text-base font-Roboto font-medium text-gray-700">
              <MdOutlineColorLens className="text-base text-gray-700" />
              Color
            </h3>
            <ul className="">
              <li
                onClick={() => handleFilters("all")}
                className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
              >
                <TiDeleteOutline
                  className="text-sm drop-shadow-md"
                  color="gray"
                />
                All
              </li>
              <li
                onClick={() => handleFilters("white")}
                className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
              >
                <CgShapeCircle
                  className="text-sm drop-shadow-md"
                  color="white"
                />
                White
              </li>
              <li
                onClick={() => handleFilters("black")}
                className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
              >
                <CgShapeCircle
                  className="text-sm drop-shadow-md"
                  color="black"
                />
                Black
              </li>
              <li
                onClick={() => handleFilters("silver")}
                className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
              >
                <CgShapeCircle
                  className="text-sm drop-shadow-md"
                  color="silver"
                />
                Silver
              </li>
              <li
                onClick={() => handleFilters("green")}
                className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
              >
                <CgShapeCircle
                  className="text-sm drop-shadow-md"
                  color="green"
                />
                Green
              </li>
              <li
                onClick={() => handleFilters("purple")}
                className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
              >
                <CgShapeCircle
                  className="text-sm drop-shadow-md"
                  color="purple"
                />
                Purple
              </li>
              <li
                onClick={() => handleFilters("blue")}
                className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
              >
                <CgShapeCircle
                  className="text-sm drop-shadow-md"
                  color="blue"
                />
                Blue
              </li>
              <li
                onClick={() => handleFilters("red")}
                className="category inline-flex gap-2 m-1 py-1 px-2 bg-gray-100 rounded-xl items-center text-sm font-Roboto font-medium text-gray-500"
              >
                <CgShapeCircle className="text-sm drop-shadow-md" color="red" />
                Red
              </li>
            </ul>
          </div>

          <div className="brand flex flex-col mb-2">
            <h3 className="flex gap-2 items-center mb-4 text-base font-Roboto font-medium text-gray-700">
              <BsTags className="text-base text-gray-700" />
              Brand
            </h3>
            <ul className="ml-2 flex flex-col">
              <li
                onClick={() => handleFilters("all")}
                className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
              >
                <BsTag className="text-sm text-gray-500" />
                All
              </li>
              <li
                onClick={() => handleFilters("apple")}
                className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
              >
                <BsTag className="text-sm text-gray-500" />
                Apple
              </li>
              <li
                onClick={() => handleFilters("microsoft")}
                className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
              >
                <BsTag className="text-sm text-gray-500" />
                Microsoft
              </li>
              <li
                onClick={() => handleFilters("sony")}
                className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
              >
                <BsTag className="text-sm text-gray-500" />
                Sony
              </li>
              <li
                onClick={() => handleFilters("samsung")}
                className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
              >
                <BsTag className="text-sm text-gray-500" />
                Samsung
              </li>
              <li
                onClick={() => handleFilters("razer")}
                className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
              >
                <BsTag className="text-sm text-gray-500" />
                Razer
              </li>
              <li
                onClick={() => handleFilters("logitech")}
                className="category flex gap-2 items-center text-sm font-Roboto font-medium text-gray-500 p-1 pl-0 pb-3"
              >
                <BsTag className="text-sm text-gray-500" />
                Logitech
              </li>
            </ul>
          </div>
        </div>

        <div className="cards flex-1 flex-col container w-full h-full mb-4 ">
          <div className="sort flex justify-between mb-6 items-center">
            <div className="lg:hidden">
              {toggle ? (
                <MdOutlineClose
                  className="text-4xl h-8 w-8 text-gray-600"
                  onClick={() => setToggle(!toggle)}
                />
              ) : (
                <MdOutlineMenu
                  className="text-4xl h-8 w-8 text-gray-600"
                  onClick={() => setToggle(!toggle)}
                />
              )}
            </div>

            <div className="filter items-center flex justify-center gap-2">
              <h2 className="text-base text-gray-600 font-Roboto font-medium mb-1">
                Filter:
              </h2>
              <select
                name="filter"
                onChange={(e) => handleSort(e.target.value)}
                className="p-2 text-gray-400 text-sm font-Roboto text-start bg-white border border-gray-300 rounded"
              >
                <option value="newest">Newest</option>
                <option value="oldest">Oldest</option>
                <option value="low">Price Low</option>
                <option value="hight">Price Hight</option>
              </select>
            </div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-2 lg:gap-8 justify-items-center">
            {filters?.map((product) => (
              <div
                key={product._id}
                className="card flex flex-col h-full w-full bg-gray-50 shadow-md rounded-md overflow-hidden justify-between"
              >
                <Link to={"/product/" + product._id}>
                  <div className="imgBox h-28 md:h-44 w-full object-cover relative">
                    <p className="brand text-sm text-gray-300 font-medium drop-shadow-md absolute top-0 left-0 z-10">
                      {product.brand}
                    </p>
                    <img
                      className="h-full w-full object-cover"
                      src={product.image}
                      alt="product"
                    />
                  </div>
                  <div className="info my-2 px-1">
                    <div className="container flex justify-between mb-2">
                      <h3 className="text-xs md:text-base text-black font-Roboto font-medium text-start">
                        {product.title.length > 19
                          ? product.title.substr(0, 18) + ".."
                          : product.title}
                      </h3>
                      <h3 className="text-xs md:text-base text-black font-Roboto font-medium">
                        ${product.price}
                      </h3>
                    </div>
                    <div className="flex items-center justify-center">
                      {product.color.map((c, index) => (
                        <span
                          key={c + index}
                          style={{ backgroundColor: c }}
                          className="w-4 h-4 rounded-full mx-1 drop-shadow-md"
                        ></span>
                      ))}
                    </div>
                  </div>
                </Link>
                <button onClick={()=> dispatch(addProduct({ ...product, quantity: 1 })) }
                 className="p-1 mt-2 w-full bg-gray-200 text-gray-500 text-sm font-Roboto font-normal md:text-lg md:font-medium hover:bg-gray-300 transition-all">
                  Add to bag
                </button>
              </div>
            ))}

            {filters?.length <= 0 ? (
              <p className="text-base text-gray-600 font-Roboto font-medium ">
                No product found
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default Categories;
